// extracted by mini-css-extract-plugin
module.exports = {"uniBlue":"#00adef","citiesSection":"citiesSection-module--cities-section--1Voz2"};